import { Link } from "react-router-dom";
import { hotKeywords } from "@/mocks/topics";

export default function NewsTicker() {
  return (
    <div className="flex items-stretch overflow-hidden border-y border-background-200 bg-background-100">
      <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-2.5 font-label text-xs text-background-50">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-flashlight-fill" aria-hidden="true" />
        </span>
        <span className="whitespace-nowrap">爆料速递</span>
      </div>
      <div className="relative flex-1 overflow-hidden py-2.5">
        <div className="bk-ticker-track">
          {[0, 1].map((round) => (
            <div key={round} className="flex items-center" aria-hidden={round === 1}>
              {hotKeywords.map((word) => (
                <Link
                  key={`${round}-${word}`}
                  to="/topics"
                  className="mx-4 flex cursor-pointer items-center gap-1.5 whitespace-nowrap font-label text-xs text-foreground-600 transition-colors hover:text-primary-600"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
                  {word}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
      <Link
        to="/polls"
        className="hidden shrink-0 items-center gap-1 border-l border-background-200 px-4 font-label text-xs text-secondary-700 transition-colors hover:bg-secondary-50 sm:flex"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-bar-chart-2-line" aria-hidden="true" />
        </span>
        投票风向
      </Link>
    </div>
  );
}